import awsAuthErrorTypes from '../../consts/aws/awsAuthErrorTypes';
import awsAuthService from '../aws/awsAuthService';
import httpStatusTypesService from '../httpStatusTypesService';

const handleRequestError = ({e}) => {
    const {response} = e ?? {};

    const isNotAuthorized = httpStatusTypesService.getIsNotAuthorized(response?.status);

    if (!isNotAuthorized) return;

    awsAuthService.handleAuthenticationError({code: awsAuthErrorTypes.NOT_AUTHORIZED_EXCEPTION});
};

export default {
    handleRequestError,
};
